let Sellers = [
  "The Banarasi Store",
  "SHUBHARAMBH VENTURES",
  "SMART HANDICRAFT",
  "GOOD PRICE STORE",
  "KOTTY LIFESTYLE LIMITED",
  "V King Kohli",
  "Satyasaidata",
  "Shivtrader",
  "Aromatic",
  "happy creation sarees",
  "BANSIWAL ENTERPRISES",
  "Shershaan",
  "Mangalsutras",
  "BRAND PLUS TRADING",
  "Krishna Enterprises",
  "H F WARSI GARMENTS",
  "VISENAFAB",
  "Vanitha Tex",
  "NEW INDIA ENTERPRISES",
  "CRAFTOS HANDICRAFTS",
  "Rudu fashion",
  "Vansh Enterprises",
  "BHARTI TRADING CO.",
  "aditi_fashion",
  "Studio 51 Clothing Co",
  "Bewitched Boutique ",
  "Zalya",
  "Retro Walk",
  "Fashionista ",
  "Dwell check",
  "Finest Stitch",
  "Clean Clothe",
  "Overall",
  "The Strange",
  "Manner Pro",
  "Civilian Costume",
  "The Soft Apparel",
  "DistinctTrends",
  "BrightClothing",
  "RomanFashion check",
  "Magnificent check",
  "The Observed check",
  "Cut Place check",
  "Couture Group check",
  "NeuroticTrends check",
  "Dress Place ",
  "The Contemporary",
  "LightClothing",
  "The Day Garb",
  "Fashioned Fashion",
  "Wardrobe Spot ",
  "TatteredClothing",
  "The Best",
  "FreshApparel",
  "National Cut",
  "The Haphazard Mode",
  "Enough Apparel",
  "HandClothing",
  "Term Temporal",
  "Captain Fashion",
  "The Coarse",
];

let Fabrics = [
  "Cotton",
  "Denim",
  "Silk",
  "Natural",
  "Felt",
  "Velvet",
  "Rayon",
  "Wool",
  "Satin",
  "Jacqurd",
  "Chiffon",
  "Bazie",
  "Twill",
  "Dimity",
];

let Patterns = [
  "Flame Stitch",
  "Basketweave",
  "Brocade",
  "Checked",
  "Damask",
  "Chevron",
  "Chinoiserie",
  "Floral",
  "Geometric",
  "Harlequin",
  "Ikat",
  "Jacquard",
  "Paisley",
  "Medallion",
  "Khadi Print",
  "Puff Paint",
  "Metallic Paint",
];
const random = (arr) => arr[Math.floor(Math.random() * arr.length)];

let allProducts = [
  {
    name: "Trendy Pretty Kurtis",
    type: "Women Ethnic",
    id: 1,
    sprice: 410,
    aprice: 460,
    rating: 4,
    reviews: 69,
    img: "https://images.meesho.com/images/products/41713416/fef4b_512.jpg",
    similar: [
      "https://images.meesho.com/images/products/41713416/fef4b_64.jpg",
      "https://images.meesho.com/images/products/41713413/q3btt_64.jpg",
      "https://images.meesho.com/images/products/41713420/3wilt_64.jpg",
      "https://images.meesho.com/images/products/41713412/0km8u_64.jpg",
      "https://images.meesho.com/images/products/41713419/zexlg_64.jpg",
    ],
    soldBy: "NDS CREATION",
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      "Pattern : Embroidered",
      "Combo of : Single",
    ],
  },
  {
    name: "Charvi Fabulous Kurtis",
    type: "Women Ethnic",
    id: 2,
    sprice: 586,
    aprice: 636,
    rating: 3.3,
    reviews: 37,
    img: "https://images.meesho.com/images/products/37966089/zfwrk_512.jpg",
    similar: [
      "https://images.meesho.com/images/products/37966092/z95vw_64.jpg",
      "https://images.meesho.com/images/products/41713413/q3btt_64.jpg",
      "https://images.meesho.com/images/products/37966094/vkwzl_64.jpg",
      "https://images.meesho.com/images/products/41713412/0km8u_64.jpg",
      "https://images.meesho.com/images/products/37966096/fesde_64.jpg",
    ],
    soldBy: "Indian Chikan Factory",
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aishani Petite Salwar Suits & Dress Materials",
    type: "Women Ethnic",
    id: 3,
    sprice: 431,
    aprice: 481,
    rating: 3.9,
    reviews: 12,
    img: "https://images.meesho.com/images/products/30839757/fqcds_512.jpg",
    similar: [
      "https://images.meesho.com/images/products/30839755/3kghp_64.jpg",
      "https://images.meesho.com/images/products/30839758/u1qqh_64.jpg",
      "https://images.meesho.com/images/products/30839754/unhcr_64.jpg",
      "https://images.meesho.com/images/products/34300107/lou0b_512.jpg",
    ],
    soldBy: "Aadil Handloom",
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      "Pattern : Embroidered",
      "Combo of : Single",
    ],
  },
  {
    name: "Sensational Silk Sarees",
    type: "Women Ethnic",
    id: 4,
    sprice: 364,
    aprice: 414,
    rating: 4,
    reviews: 5,
    img: "https://images.meesho.com/images/products/34300107/lou0b_512.jpg",
    similar: [
      "https://images.meesho.com/images/products/34300107/lou0b_64.jpg",
    ],
    soldBy: "MAN TEXO FEB",
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aagam Fabulous Sarees",
    type: "Women Ethnic",
    id: 5,
    sprice: 392,
    aprice: 450,
    rating: 4.5,
    reviews: 45,
    img: "https://images.meesho.com/images/products/40939196/zb2az_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: "MAN TEXO FEB",
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      "Pattern : Embroidered",
      "Combo of : Single",
    ],
  },
  {
    name: "KURTA AND SHARARA",
    type: "Women Ethnic",
    id: 6,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: 45,
    img: "https://images.meesho.com/images/products/72562099/1c3qr_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Adrika Voguish Sarees",
    type: "Women Ethnic",
    id: 7,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97453327/gyvok_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Refined Sarees",
    type: "Women Ethnic",
    id: 8,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97453482/q8zip_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Graceful Sarees",
    type: "Women Ethnic",
    id: 9,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97448799/if7ad_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Chitrarekha Sensational Kurtis",
    type: "Women Ethnic",
    id: 10,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49932684/uvgg1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Alisha Voguish Kurtis",
    type: "Women Ethnic",
    id: 11,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/67148994/lmhpj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Salwar Suits Petite",
    type: "Women Ethnic",
    id: 12,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/30839757/fqcds_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Alluring Salwar Suits",
    type: "Women Ethnic",
    id: 13,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81215646/xm4pu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Adrika Fashionable Salwar",
    type: "Women Ethnic",
    id: 14,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70189638/agk3t_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Cotton Suits",
    type: "Women Ethnic",
    id: 15,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/34035307/txla4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Voguish Salwar ",
    type: "Women Ethnic",
    id: 16,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/13175971/a710c_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Materials",
    type: "Women Ethnic",
    id: 17,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97447834/7hhry_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Abstract Chiffon Suits",
    type: "Women Ethnic",
    id: 18,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60247644/umnkp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Versatile Trendy Dupattas",
    type: "Women Ethnic",
    id: 19,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49322714/oebxh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Stylish Women Dupattas",
    type: "Women Ethnic",
    id: 20,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/48698989/bwhip_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Revishinh Women Dupattas",
    type: "Women Ethnic",
    id: 21,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81911449/zybz0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fashionable Dupattas",
    type: "Women Ethnic",
    id: 22,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53779093/ujh0x_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Fashion Duppatas",
    type: "Women Ethnic",
    id: 23,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81446505/tmwsr_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Ethnic Duppatas",
    type: "Women Ethnic",
    id: 24,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/52253571/gelxd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Cotton Suits",
    type: "Women Ethnic",
    id: 25,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/46306881/8qffp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Superior Suits",
    type: "Women Ethnic",
    id: 26,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/44401618/ablpe_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegant Suits",
    type: "Women Ethnic",
    id: 27,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/35758181/9nrty_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Kashvi Pretty Suits",
    type: "Women Ethnic",
    id: 28,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/32753720/li8gk_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Pretty Suit",
    type: "Women Ethnic",
    id: 29,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/67535883/rlw1p_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Alluring Kurtis",
    type: "Women Ethnic",
    id: 30,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84550725/jpvso_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Alsiha Salwars",
    type: "Women Ethnic",
    id: 31,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49935886/fhyup_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Kurti Fabrics",
    type: "Women Ethnic",
    id: 32,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66385501/ukyer_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Kurti",
    type: "Women Ethnic",
    id: 33,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76507419/gbkuw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sensational Sarees",
    type: "Women Ethnic",
    id: 34,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97458221/aoyer_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Ensemble Sarees",
    type: "Women Ethnic",
    id: 35,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97451543/ffd6r_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Jivika Pretty Sarees",
    type: "Women Ethnic",
    id: 36,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97417579/qplox_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Charvi Voguish Sarees",
    type: "Women Ethnic",
    id: 37,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97434427/qmvnb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aagam Refined Sarees",
    type: "Women Ethnic",
    id: 38,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97434412/lesdl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aakarsha Sarees",
    type: "Women Ethnic",
    id: 39,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97427166/ehnzc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Asihani Fashion Duppatas",
    type: "Women Ethnic",
    id: 40,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59168677/rqqeq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Women Sarees",
    type: "Women Ethnic",
    id: 41,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97423251/ip3br_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Pretty Kurtis",
    type: "Women Ethnic",
    id: 42,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/29306320/20dd8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Myra Drishya Kurtis",
    type: "Women Ethnic",
    id: 43,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60156559/b7rdb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Abhisarika Kurtis",
    type: "Women Ethnic",
    id: 44,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82142614/cqxvt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Refined Kurtis",
    type: "Women Ethnic",
    id: 45,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/51478065/f436t_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sensational Kurtis",
    type: "Women Ethnic",
    id: 46,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11397330/52a57_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Banita Sarees",
    type: "Women Ethnic",
    id: 47,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97415569/cwuts_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Adrika Graceful Kurtis",
    type: "Women Ethnic",
    id: 48,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62215121/dslif_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Myra Suits Salwar",
    type: "Women Ethnic",
    id: 49,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65420381/ugedl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Alluring Salwar Suits",
    type: "Women Ethnic",
    id: 50,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65953365/otd97_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Women Lehenga",
    type: "Women Ethnic",
    id: 51,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83528690/dznjy_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aagyeyi Sensational Women",
    type: "Women Ethnic",
    id: 52,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45660991/xfiwl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Jivika Women",
    type: "Women Ethnic",
    id: 53,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/29664520/c108b_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Lehenga Superior",
    type: "Women Ethnic",
    id: 54,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11984978/e8ea4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aishni Refined Sarees",
    type: "Women Ethnic",
    id: 55,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97414629/obwsh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Chrvi Refined",
    type: "Women Ethnic",
    id: 56,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97418391/u0rew_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Kashi Sarees",
    type: "Women Ethnic",
    id: 57,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97411994/i7eoz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Myra Voguish Sarees",
    type: "Women Ethnic",
    id: 58,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97414360/yglgm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aishani Fashionable Kurtis",
    type: "Women Ethnic",
    id: 59,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3711768/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aishani Latest Kurtis",
    type: "Women Ethnic",
    id: 60,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70316281/8ery0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aishani New Kurtis",
    type: "Women Ethnic",
    id: 61,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78066875/zxdlu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aa Fashionable Kurtis",
    type: "Women Ethnic",
    id: 62,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69700680/uitba_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aishani Fashion Kurtis",
    type: "Women Ethnic",
    id: 63,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/80160071/rxlbf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Semi-Stitched Suits Salwars",
    type: "Women Ethnic",
    id: 64,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54579361/uxmhb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Kurtas Stitched Suits",
    type: "Women Ethnic",
    id: 65,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65407412/xlnei_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Full-Stitched Suits",
    type: "Women Ethnic",
    id: 66,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53284303/ryl2f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Half Stitched Suits",
    type: "Women Ethnic",
    id: 67,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60302907/ghfco_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Modern Full Dresses",
    type: "Women Ethnic",
    id: 68,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6434963/43462_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Modern Salwar Dresses",
    type: "Women Ethnic",
    id: 69,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/46416850/jgbkr_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Latest Women Dresses",
    type: "Women Ethnic",
    id: 70,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70351877/pmwzc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Stiched Women Dresses",
    type: "Women Ethnic",
    id: 71,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54961918/vcapg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sarees Ethnic Dresses",
    type: "Women Ethnic",
    id: 72,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97093452/qja4t_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Modern Half Dresses",
    type: "Women Ethnic",
    id: 73,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27071947/b8d87_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Modern Narrow Dresses",
    type: "Women Ethnic",
    id: 74,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77267791/kc6sr_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Modern Women Kurtee",
    type: "Women Ethnic",
    id: 75,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68310071/397mx_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Pretty Salwar Dresses",
    type: "Women Ethnic",
    id: 76,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/9188995/9eb46_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Pretty Suits Dresses",
    type: "Women Ethnic",
    id: 77,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/37950665/ok3uj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Morden Pretty Dresses",
    type: "Women Ethnic",
    id: 78,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82202208/r1kup_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sarees Pretty Dresses",
    type: "Women Ethnic",
    id: 79,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97402944/9jqw1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Pretty Half Dresses",
    type: "Women Ethnic",
    id: 80,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84912970/w26gh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Pretty Adorable Dresses",
    type: "Women Western",
    id: 81,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66840120/klilc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Pretty Salwars",
    type: "Women Western",
    id: 82,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82179630/htqde_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fabric Feminine",
    type: "Women Western",
    id: 83,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82686854/zcxwr_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Retro Fabric Feminine",
    type: "Women Western",
    id: 84,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45636641/nsprg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Raabta Adelyn Feminine",
    type: "Women Western",
    id: 85,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60140080/qdfs9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Women Adelyn Feminine",
    type: "Women Western",
    id: 86,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/67240284/pzgug_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Raabta Stylish Women",
    type: "Women Western",
    id: 87,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16572362/50b98_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Raabta Dresses Feminine",
    type: "Women Western",
    id: 88,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49716623/sbami_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Morden Pretty Dresses",
    type: "Women Western",
    id: 89,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61502423/bmbci_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "half Ethnic Feminine",
    type: "Women Western",
    id: 90,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/22264347/5f177_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Raabta Silk Sarees",
    type: "Women Western",
    id: 91,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/94027193/pgttx_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Raabta Fashion Kurtees",
    type: "Women Western",
    id: 92,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65092382/1o2qt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Morden Fashion Feminine",
    type: "Women Western",
    id: 93,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76770707/ukxmt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Raabta Salwar Feminine",
    type: "Women Western",
    id: 94,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/19108460/6b02d_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aagan Kurtis",
    type: "Women Western",
    id: 95,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74052349/6lsoz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Ensemble Kurti",
    type: "Women Western",
    id: 96,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81120731/fhpkp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Jivika Women Kurtas",
    type: "Women Western",
    id: 97,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63953931/9clnl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Essentials Kurtis",
    type: "Women Western",
    id: 98,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77259250/cfv3r_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Charvi Kurta Sets",
    type: "Women Western",
    id: 99,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66840120/klilc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Abhisarika Kurtis Trendy",
    type: "Women Western",
    id: 100,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42003414/0wjlf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?dress",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?shirts",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Sensational Tops",
    type: "Women Western",
    id: 101,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/12569934/cf232_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Upcoming Dresses.",
    type: "Women Western",
    id: 102,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/23409968/52ad1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Abhishareika Western Palazzos",
    type: "Women Western",
    id: 103,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72096487/4bq4l_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Alluring Salwar Abhisarika",
    type: "Women Western",
    id: 104,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/12265535/75524_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Adrika Fashionable Dresses",
    type: "Women Western",
    id: 105,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27074167/e5a96_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Jivika Drishya Sweatshirts",
    type: "Women Western",
    id: 106,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71263457/tyx7q_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Banita Sarees Kurtas",
    type: "Women Western",
    id: 107,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/48178755/w7mnf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Charvi Drishya Kurtas",
    type: "Women Western",
    id: 108,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/40589118/hvt0c_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Glamorous Ethnic Feminine",
    type: "Women Western",
    id: 109,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69391218/bx9h0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fashionista Pro Dresses",
    type: "Women Western",
    id: 110,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/85000917/xykur_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classic Retro Designed",
    type: "Women Western",
    id: 111,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69455655/29dz4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Graceful Jumpsuits",
    type: "Women Western",
    id: 112,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/8950072/1e896_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Women Jumpsuits",
    type: "Women Western",
    id: 113,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61007697/zmdnn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Urbane Partywear Jumpsuits",
    type: "Women Western",
    id: 114,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41988723/kefqc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Women Jumpsuits",
    type: "Women Western",
    id: 115,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61007697/zmdnn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Fabrics Suits",
    type: "Women Western",
    id: 116,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53387918/aqlhx_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Designed Jumpsuits",
    type: "Women Western",
    id: 117,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70326491/7r6sw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Latest Jeans",
    type: "Women Western",
    id: 118,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83558007/6kdtn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Sensational Tops",
    type: "Women Western",
    id: 119,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6035901/f77d8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegant COmfy Sweters",
    type: "Women Western",
    id: 120,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66527857/00int_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Western Dresses",
    type: "Women Western",
    id: 121,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/73770045/gn3r2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fabric Women Palazzos ",
    type: "Women Western",
    id: 122,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/48783008/tm6sy_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Morden Fashion Shirts",
    type: "Women Western",
    id: 123,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78983793/bfhbf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Preety Western Sweatshirts",
    type: "Women Western",
    id: 124,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74184720/y2nht_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Partywear Capes Classic",
    type: "Women Western",
    id: 125,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63003745/whiv3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classic Women Caps",
    type: "Women Western",
    id: 126,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/15069106/dc18f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "TrendyFrog Designer Denim",
    type: "Women Western",
    id: 127,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81703113/wy7mi_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Parinaaz Adorable Hosiery",
    type: "Women Western",
    id: 128,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6994648/02f4b_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Glamorous Women Capes",
    type: "Women Western",
    id: 129,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/38526183/ige8l_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Urbane Glamorous Tshirts",
    type: "Women Western",
    id: 130,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41988723/kefqc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Ashini Graceful Kurtis",
    type: "Women Western",
    id: 131,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82311479/pecbi_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Capris Ethnic Western",
    type: "Women Western",
    id: 132,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72743730/xwsn4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Women Trousers Feminine",
    type: "Women Western",
    id: 133,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6425170/a39bd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fashionista Western Dresses",
    type: "Women Western",
    id: 134,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49606321/ygsup_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Feminine Women Dress",
    type: "Women Western",
    id: 135,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/17905111/90663_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Women Palazzos",
    type: "Women Western",
    id: 136,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16401345/63ef6_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegant Women Palazzos",
    type: "Women Western",
    id: 137,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/10757329/4cd88_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Ravishing Unique Palazzos",
    type: "Women Western",
    id: 138,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/35862892/paloq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegat Western Palazzos",
    type: "Women Western",
    id: 139,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82611379/n9xeu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Jiva Trendy Palazzos",
    type: "Women Western",
    id: 140,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/4406271/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Morden Pretty Trousers",
    type: "Women Western",
    id: 141,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/51675206/xyvpa_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fashionista Women Dresses",
    type: "Women Western",
    id: 142,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16204526/534a7_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Retro Stylish Women Trousers",
    type: "Women Western",
    id: 143,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65939620/rlmwg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classic Designed Trousers",
    type: "Women Western",
    id: 144,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/47840671/nxxuu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Urbane Elegant Trousers",
    type: "Women Western",
    id: 145,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61606407/dil5z_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Kotty Latest Designed Cloths",
    type: "Women Western",
    id: 146,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6886912/4c117_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Western Fashionable",
    type: "Women Western",
    id: 147,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/85068858/rhiix_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Women Graceful Jeans",
    type: "Women Western",
    id: 148,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42256758/fd6p4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classic Fabulous Jeans",
    type: "Women Western",
    id: 149,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45977032/tbjol_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Fabulous Jeans",
    type: "Women Western",
    id: 150,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/48481273/zg9sc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Retro Sweatshirts",
    type: "Women Western",
    id: 151,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/18957942/c6385_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Pretty Retro Women Sweters",
    type: "Women Western",
    id: 152,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74198565/o4f8s_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Partywear Stylish Tops",
    type: "Women Western",
    id: 153,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/38149289/eozgu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Pretty Design Patterns",
    type: "Women Western",
    id: 154,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41244178/ch86d_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Glamorous Tops",
    type: "Women Western",
    id: 155,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/19303116/3dba0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Fabulous Tunics",
    type: "Women Western",
    id: 156,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83712250/tkjvd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Retro Women Tops",
    type: "Women Western",
    id: 157,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63963792/s55s0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Tunics Classy Tops",
    type: "Women Western",
    id: 158,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41244178/ch86d_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegant Women Tops",
    type: "Women Western",
    id: 159,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/21035908/6bb9e_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Partywear Women Tops",
    type: "Women Western",
    id: 160,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66677842/w9edu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?girl",
      "https://source.unsplash.com/random/?cloths",
      "https://source.unsplash.com/random/?women",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Trendy Stylish Handbag",
    type: "Jewellery & Accessories",
    id: 161,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74296211/ayohz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Alluring Graceful Handbags",
    type: "Jewellery & Accessories",
    id: 162,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42109439/p04ls_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Elegant Versatile Handbag",
    type: "Jewellery & Accessories",
    id: 163,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/23565042/a1d6f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Trendy Fashinable Handbag",
    type: "Jewellery & Accessories",
    id: 164,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41694868/ngdjd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Classy Women Handbags",
    type: "Jewellery & Accessories",
    id: 165,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/87231000/o8mhh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Voguish Stylish Handbags",
    type: "Jewellery & Accessories",
    id: 166,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71072836/vr5hw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Graceful Versitile Women Bags",
    type: "Jewellery & Accessories",
    id: 167,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/25422315/8b071_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Elite Stylish Handbags",
    type: "Jewellery & Accessories",
    id: 168,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84265909/aifqu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Versitile Women Handbags",
    type: "Jewellery & Accessories",
    id: 169,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68575347/uswx9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Fancy Handbags",
    type: "Jewellery & Accessories",
    id: 170,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/31916741/acp2b_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Unique Watches",
    type: "Jewellery & Accessories",
    id: 171,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/36793304/hvrg8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Classic Watches",
    type: "Jewellery & Accessories",
    id: 172,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/31145560/00776_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Attractive Women Watches",
    type: "Jewellery & Accessories",
    id: 173,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16734116/22c37_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Stylish Watches",
    type: "Jewellery & Accessories",
    id: 174,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/36890051/to5b5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Attractive Western Watches",
    type: "Jewellery & Accessories",
    id: 175,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/33681383/pf1bz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "New Latest Watches",
    type: "Jewellery & Accessories",
    id: 176,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/37601768/j0zmm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Smart Watches",
    type: "Jewellery & Accessories",
    id: 177,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/36948538/mqdkp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "New Wrist Watches",
    type: "Jewellery & Accessories",
    id: 178,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/17433178/99606_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Latest Devine Watches",
    type: "Jewellery & Accessories",
    id: 179,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/17687144/20bf0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Handwatches For Stone",
    type: "Jewellery & Accessories",
    id: 180,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/40669100/jessf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Fancy Sunglasses",
    type: "Jewellery & Accessories",
    id: 181,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/64453330/neg3e_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Comfortable Sunglasses",
    type: "Jewellery & Accessories",
    id: 182,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59551142/aj4bv_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Unique Sunglasses",
    type: "Jewellery & Accessories",
    id: 183,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76788332/h98pi_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Morden Sunglasses",
    type: "Jewellery & Accessories",
    id: 184,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/87922029/0kzxp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Causal Sunglasses",
    type: "Jewellery & Accessories",
    id: 185,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41215167/74wi8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Frameless Sunglass",
    type: "Jewellery & Accessories",
    id: 186,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/43329926/gm5mq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Trendy Sunglass",
    type: "Jewellery & Accessories",
    id: 187,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79503655/sqgp4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Fashionable Sunglasses",
    type: "Jewellery & Accessories",
    id: 188,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60325032/fxdrb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Stylish Agile Glass",
    type: "Jewellery & Accessories",
    id: 189,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/50692904/bvjju_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Black Goggles",
    type: "Jewellery & Accessories",
    id: 190,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41531653/mujbo_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Shimmerning Jewellery",
    type: "Jewellery & Accessories",
    id: 191,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71866007/cbpb8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Shimmerning Jewellery",
    type: "Jewellery & Accessories",
    id: 192,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53464374/wy1o9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Shimmerning Jewellery",
    type: "Jewellery & Accessories",
    id: 193,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71615140/toiee_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Shimmerning Jewellery",
    type: "Jewellery & Accessories",
    id: 194,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69371749/5myvh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Twinkling Glittering Set",
    type: "Jewellery & Accessories",
    id: 195,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81033505/nrnvg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Twinkling Glittering Set",
    type: "Jewellery & Accessories",
    id: 196,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65541214/2zk7z_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Twinkling Glittering Set",
    type: "Jewellery & Accessories",
    id: 197,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/8271506/0a8a6_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Twinkling Glittering Set",
    type: "Jewellery & Accessories",
    id: 198,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/23750876/5143a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Colorful Jewellery",
    type: "Jewellery & Accessories",
    id: 199,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78066568/vkvzs_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Colorful Jewellery",
    type: "Jewellery & Accessories",
    id: 200,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/5940296/ce587_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Stylo Earrings",
    type: "Jewellery & Accessories",
    id: 201,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/52707380/tdnds_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Diva Colorful Earring",
    type: "Jewellery & Accessories",
    id: 202,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/24197578/62f13_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Earring and Studs",
    type: "Jewellery & Accessories",
    id: 203,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/50751650/q4kzk_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Classic Earrings",
    type: "Jewellery & Accessories",
    id: 204,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45570785/pte1n_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Fashionable Studs",
    type: "Jewellery & Accessories",
    id: 205,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/55140171/1ahyu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "New Colorful Earrings",
    type: "Jewellery & Accessories",
    id: 206,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63066702/la8vz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Morden Elegent",
    type: "Jewellery & Accessories",
    id: 207,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60164333/4wnxu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Divine Earrings",
    type: "Jewellery & Accessories",
    id: 208,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81147138/6qhip_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Twinkling Earrings",
    type: "Jewellery & Accessories",
    id: 209,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61871013/ohwdj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "New Earrings",
    type: "Jewellery & Accessories",
    id: 210,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72092492/a5ua6_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Elite Fancy Rings",
    type: "Jewellery & Accessories",
    id: 211,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78121511/t3o5y_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Elite Fancy Rings",
    type: "Jewellery & Accessories",
    id: 212,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/73599274/tv3bi_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Elite Fancy Rings",
    type: "Jewellery & Accessories",
    id: 213,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/75848230/pldqe_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Elite Fancy Rings",
    type: "Jewellery & Accessories",
    id: 214,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49503587/t95re_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Elite Fancy Rings",
    type: "Jewellery & Accessories",
    id: 215,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/48951598/ygpui_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Alite Bejeweled Rings",
    type: "Jewellery & Accessories",
    id: 216,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/57720236/iasim_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Alite Bejeweled Rings",
    type: "Jewellery & Accessories",
    id: 217,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/46751670/2gfh6_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Alite Bejeweled Rings",
    type: "Jewellery & Accessories",
    id: 218,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62500595/x1e0r_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Alite Bejeweled Rings",
    type: "Jewellery & Accessories",
    id: 219,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74099480/ndoba_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Alite Bejeweled Rings",
    type: "Jewellery & Accessories",
    id: 220,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62948347/icmbh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?earring",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Glittering Anklet",
    type: "Jewellery & Accessories",
    id: 221,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16568427/4603f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Glittering Anklet",
    type: "Jewellery & Accessories",
    id: 222,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77824407/quyka_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Glittering Anklet",
    type: "Jewellery & Accessories",
    id: 223,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54633756/mpvlw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Glittering Anklet",
    type: "Jewellery & Accessories",
    id: 224,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/44196633/nmyxz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Glittering Anklet",
    type: "Jewellery & Accessories",
    id: 225,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/67638358/pqcul_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Chunky Women Anklets",
    type: "Jewellery & Accessories",
    id: 226,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/43075998/aay54_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Chunky Women Anklets",
    type: "Jewellery & Accessories",
    id: 227,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45872144/ujeq3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Chunky Women Anklets",
    type: "Jewellery & Accessories",
    id: 228,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/44226329/rw9an_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Chunky Women Anklets",
    type: "Jewellery & Accessories",
    id: 229,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54457028/jfyrf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Chunky Women Anklets",
    type: "Jewellery & Accessories",
    id: 230,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70469871/c457f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?braceletes",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Fancy Necklaces",
    type: "Jewellery & Accessories",
    id: 231,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/75726181/j0ih2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Fancy Necklaces",
    type: "Jewellery & Accessories",
    id: 232,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/47239198/hznvp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Fancy Necklaces",
    type: "Jewellery & Accessories",
    id: 233,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/57207699/deqht_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Fancy Necklaces",
    type: "Jewellery & Accessories",
    id: 234,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70688148/kboz6_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Sizzling Fancy Necklaces",
    type: "Jewellery & Accessories",
    id: 235,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66296588/fuzmj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Latest Manalsutras",
    type: "Jewellery & Accessories",
    id: 236,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/85249428/mvoya_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Latest Manalsutras",
    type: "Jewellery & Accessories",
    id: 237,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70062412/latdw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Latest Manalsutras",
    type: "Jewellery & Accessories",
    id: 238,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83117675/wjxv1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Latest Manalsutras",
    type: "Jewellery & Accessories",
    id: 239,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/86846353/iqb6e_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Latest Manalsutras",
    type: "Jewellery & Accessories",
    id: 240,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/18825190/3a2d1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?ring",
      "https://source.unsplash.com/random/?gold",
    ],
    soldBy: random(Sellers),
    details: [
      `Base Metal : Allow, Silver`,
      "Stone Type : Artificial Stones",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Double",
    ],
  },
  {
    name: "Urban Morden Men Tshirts",
    type: "Men",
    id: 241,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69505698/tdy0a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Urban Morden Men Tshirts",
    type: "Men",
    id: 242,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59944831/b46tw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classic Fashioninsta Tshirts",
    type: "Men",
    id: 243,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45400600/2mqzk_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classic Fashioninsta Tshirts",
    type: "Men",
    id: 244,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70682477/6jicr_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Divine Men's Solid Tshirt",
    type: "Men",
    id: 245,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53578166/oftcq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Divine Men's Solid Tshirt",
    type: "Men",
    id: 246,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/18141968/ee604_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fashionable Men Tshits",
    type: "Men",
    id: 247,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/86773575/zhook_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fashionable Men Tshits",
    type: "Men",
    id: 248,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/39248637/enefq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Blend Men's Shirts",
    type: "Men",
    id: 249,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63451223/sameh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Blend Men's Shirts",
    type: "Men",
    id: 250,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/17419844/e84c0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Blend Men's Shirts",
    type: "Men",
    id: 251,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/273152/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Ravishing Shirts",
    type: "Men",
    id: 252,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3027555/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Ravishing Shirts",
    type: "Men",
    id: 253,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/14355188/69973_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Ravishing Shirts",
    type: "Men",
    id: 254,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/1120526/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegant Men's Shirts",
    type: "Men",
    id: 255,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/9180941/f00e3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegant Men's Shirts",
    type: "Men",
    id: 256,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/5106629/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?tshirt",
      "https://source.unsplash.com/random/?shirt",
      "https://source.unsplash.com/random/?cloths",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Unique Men Jeans",
    type: "Men",
    id: 257,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/1515684/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jeans",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Unique Men Jeans",
    type: "Men",
    id: 258,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/8187585/d7e3f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jeans",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Unique Men Jeans",
    type: "Men",
    id: 259,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7669718/6fa76_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jeans",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Unique Men Jeans",
    type: "Men",
    id: 260,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69083701/ct6pn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jeans",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Fashionista Jeans",
    type: "Men",
    id: 261,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/51035784/oxcsf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jeans",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Fashionista Jeans",
    type: "Men",
    id: 262,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/26281389/1d410_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jeans",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Fashionista Jeans",
    type: "Men",
    id: 263,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/46935384/oteoa_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jeans",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Fashionista Jeans",
    type: "Men",
    id: 264,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83840235/arlvf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jeans",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Ravishing Trendy Trousers",
    type: "Men",
    id: 265,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/4812913/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?trouser",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Ravishing Trendy Trousers",
    type: "Men",
    id: 266,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53439022/ccd0o_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?trouser",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Ravishing Trendy Trousers",
    type: "Men",
    id: 267,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/52255635/k0b9h_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?trouser",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Gorgeous Fab Men Trousers",
    type: "Men",
    id: 268,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/5858519/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?trouser",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Gorgeous Fab Men Trousers",
    type: "Men",
    id: 269,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3465054/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?trouser",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Gorgeous Fab Men Trousers",
    type: "Men",
    id: 270,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/57734422/cled2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?trouser",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Men Trousers",
    type: "Men",
    id: 271,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69640167/olei1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?trouser",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Fancy Men Trousers",
    type: "Men",
    id: 272,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/13316663/406b5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?trouser",
      "https://source.unsplash.com/random/?pant",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegant Men Jackets",
    type: "Men",
    id: 273,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/24176924/aae19_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegant Men Jackets",
    type: "Men",
    id: 274,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53653908/wmcym_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Elegant Men Jackets",
    type: "Men",
    id: 275,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66508391/h1tlp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Ethnic Jackets",
    type: "Men",
    id: 276,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/19705075/68d1e_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Ethnic Jackets",
    type: "Men",
    id: 277,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/25148200/d0d52_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Ethnic Jackets",
    type: "Men",
    id: 278,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53250454/c3bqt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Morden Men's Coat",
    type: "Men",
    id: 279,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41794690/vyrgu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Morden Men's Coat",
    type: "Men",
    id: 280,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41518811/3hkdx_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Smarty Men Gym Vest",
    type: "Men",
    id: 281,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/23405467/e90b7_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Smarty Men Gym Vest",
    type: "Men",
    id: 282,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/52953933/jdwib_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Smarty Men Gym Vest",
    type: "Men",
    id: 283,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/34413926/tu9qo_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sassy Men Vest",
    type: "Men",
    id: 284,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76859105/lpsei_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sassy Men Vest",
    type: "Men",
    id: 285,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/40285621/gbkkt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sassy Men Vest",
    type: "Men",
    id: 286,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/51805250/hlrhg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sassy Men Vest",
    type: "Men",
    id: 287,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53569984/oapli_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sassy Men Vest",
    type: "Men",
    id: 288,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/67198858/gcd7n_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?jacket",
      "https://source.unsplash.com/random/?coat",
      "https://source.unsplash.com/random/?shirt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Sassy Men Vest",
    type: "Men",
    id: 289,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54842041/ukydi_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Smarty Men Vest",
    type: "Men",
    id: 290,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/52774331/dz6pw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Trendy Sports Shoes",
    type: "Men",
    id: 291,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7337496/f3a89_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Trendy Sports Shoes",
    type: "Men",
    id: 292,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77759279/lickm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Trendy Sports Shoes",
    type: "Men",
    id: 293,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/14779484/fe552_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Trendy Sports Shoes",
    type: "Men",
    id: 294,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/20926286/793b4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Trendy Sports Shoes",
    type: "Men",
    id: 295,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83864231/a5vaz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Columbus Sports Trendy Shoe",
    type: "Men",
    id: 296,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78896033/kyyro_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Columbus Sports Trendy Shoe",
    type: "Men",
    id: 297,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71955571/nlmre_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Columbus Sports Trendy Shoe",
    type: "Men",
    id: 298,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69763861/7wmjv_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Columbus Sports Trendy Shoe",
    type: "Men",
    id: 299,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/2889071/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Latest Graceful Men Sandals",
    type: "Men",
    id: 300,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/19679038/30ebe_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Latest Graceful Men Sandals",
    type: "Men",
    id: 301,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84927479/quvyj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Latest Graceful Men Sandals",
    type: "Men",
    id: 302,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/73001810/sf9ku_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Latest Graceful Men Sandals",
    type: "Men",
    id: 303,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/44770225/vydao_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Aadab Trendy Men Sandals",
    type: "Men",
    id: 304,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/19580156/dd1c2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "FancyTrendy Men Wallets",
    type: "Men",
    id: 305,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72221112/hssc5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?wallet",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "FancyTrendy Men Wallets",
    type: "Men",
    id: 306,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84209710/uuqul_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?wallet",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "FancyTrendy Men Wallets",
    type: "Men",
    id: 307,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/1092148/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?wallet",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "FancyTrendy Men Wallets",
    type: "Men",
    id: 308,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60830468/pyk2m_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?wallet",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Fashion Wallets",
    type: "Men",
    id: 309,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/40155409/dedje_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?wallet",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Fashion Wallets",
    type: "Men",
    id: 310,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/55080609/v0xms_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?wallet",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Fashion Wallets",
    type: "Men",
    id: 311,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41012172/hcn8r_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?wallet",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Fashion Wallets",
    type: "Men",
    id: 312,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/8333002/fd993_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?wallet",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Men Belts",
    type: "Men",
    id: 313,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16850436/8c926_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Men Belts",
    type: "Men",
    id: 314,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60895280/yugct_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Men Belts",
    type: "Men",
    id: 315,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7281192/35cdb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Men Belts",
    type: "Men",
    id: 316,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/5592673/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Men Belts",
    type: "Men",
    id: 317,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/29171188/daqsh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Men Belts",
    type: "Men",
    id: 318,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42064149/zqetm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Men Belts",
    type: "Men",
    id: 319,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/8496318/b4fb3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New Men Belts",
    type: "Men",
    id: 320,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74524852/qvla5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      "Sleeve Length : Three-Quarter Sleeves",
      `Pattern : ${random(Patterns)}`,
      "Combo of : Single",
    ],
  },
  {
    name: "New COllection Fashpack",
    type: "Beauty & Health",
    id: 321,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/38633913/7bn2m_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "New COllection Fashpack",
    type: "Beauty & Health",
    id: 322,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/25617349/ab9a5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "New COllection Fashpack",
    type: "Beauty & Health",
    id: 323,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41511105/585a5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "New COllection Fashpack",
    type: "Beauty & Health",
    id: 324,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/73717030/m0usv_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "New COllection Fashpack",
    type: "Beauty & Health",
    id: 325,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63670000/gvdgc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "New COllection Fashpack",
    type: "Beauty & Health",
    id: 326,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49192301/pj1ld_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "New COllection Fashpack",
    type: "Beauty & Health",
    id: 327,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71036502/lwzb7_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Facepack & Scrubs",
    type: "Beauty & Health",
    id: 328,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71618619/fmajd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Facepack & Scrubs",
    type: "Beauty & Health",
    id: 329,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/13943896/9da72_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Facepack & Scrubs",
    type: "Beauty & Health",
    id: 330,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45716672/rr9nl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Facepack & Scrubs",
    type: "Beauty & Health",
    id: 331,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/12069047/b340a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Facepack & Scrubs",
    type: "Beauty & Health",
    id: 332,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11603943/b2750_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Facepack & Scrubs",
    type: "Beauty & Health",
    id: 333,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78525093/d4qvc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Facepack & Scrubs",
    type: "Beauty & Health",
    id: 334,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/44941497/s4lmh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Classy Facepack & Scrubs",
    type: "Beauty & Health",
    id: 335,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78212933/nvqza_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 336,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/13878663/a85e2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 337,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68606319/d3nxs_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 338,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7916887/e606f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 339,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54742308/q1thi_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 340,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/10419631/ounxq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 341,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/64215169/siwls_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 342,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62494759/zhckl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 343,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/15856786/78fbe_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 344,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54672670/pqhj3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 345,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/64306440/4yypa_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 346,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/67556388/sktlk_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 347,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/10700714/d3djj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 348,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66790041/vpw5g_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 349,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62276263/fmigv_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 350,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82508853/ncgvl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 351,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79829053/wxcyc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 352,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63433631/nbom2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Beauty & Health Products",
    type: "Beauty & Health",
    id: 353,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7040083/65038_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Stylish Kajal",
    type: "Beauty & Health",
    id: 354,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/88346563/a236g_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Stylish Kajal",
    type: "Beauty & Health",
    id: 355,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/13860449/87e2a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Stylish Kajal",
    type: "Beauty & Health",
    id: 356,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/15092809/f8bd6_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Stylish Kajal",
    type: "Beauty & Health",
    id: 357,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49408011/n4mls_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Stylish Kajal",
    type: "Beauty & Health",
    id: 358,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70683245/h6tg1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Stylish Kajal",
    type: "Beauty & Health",
    id: 359,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/86171173/83hoz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Stylish Kajal",
    type: "Beauty & Health",
    id: 360,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/17971464/0f80f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Sensational Gromming Kit",
    type: "Beauty & Health",
    id: 361,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41806317/neugn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Sensational Gromming Kit",
    type: "Beauty & Health",
    id: 362,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65230401/6s9wa_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Sensational Gromming Kit",
    type: "Beauty & Health",
    id: 363,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71070704/izrpw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Sensational Gromming Kit",
    type: "Beauty & Health",
    id: 364,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/20506332/4b871_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Sensational Gromming Kit",
    type: "Beauty & Health",
    id: 365,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/28122748/y6vzy_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Premium Nourishing Nail",
    type: "Beauty & Health",
    id: 366,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27088179/fb91c_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Premium Nourishing Nail",
    type: "Beauty & Health",
    id: 367,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/10278011/89157_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Premium Nourishing Nail",
    type: "Beauty & Health",
    id: 368,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/25992878/4f8e4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Premium Nourishing Nail",
    type: "Beauty & Health",
    id: 369,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/9827403/51595_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Premium Nourishing Nail",
    type: "Beauty & Health",
    id: 370,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76136622/tygbm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Quality Nail Care",
    type: "Beauty & Health",
    id: 371,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6319629/f4b47_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Quality Nail Care",
    type: "Beauty & Health",
    id: 372,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7053533/8c38b_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Quality Nail Care",
    type: "Beauty & Health",
    id: 373,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27289173/69120_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Quality Nail Care",
    type: "Beauty & Health",
    id: 374,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6872399/fbc59_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Superior Quality Nail Care",
    type: "Beauty & Health",
    id: 375,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/8100153/57db2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Graceful Nail Paint",
    type: "Beauty & Health",
    id: 376,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/8102162/bd746_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Graceful Nail Paint",
    type: "Beauty & Health",
    id: 377,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6416745/3a68d_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Graceful Nail Paint",
    type: "Beauty & Health",
    id: 378,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/40641399/zyxij_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Graceful Nail Paint",
    type: "Beauty & Health",
    id: 379,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6252594/f67e0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Graceful Nail Paint",
    type: "Beauty & Health",
    id: 380,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68950117/necd9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Smile Dent Mouth Wash",
    type: "Beauty & Health",
    id: 381,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76948251/ptzul_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Smile Dent Mouth Wash",
    type: "Beauty & Health",
    id: 382,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72354759/hnela_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Smile Dent Mouth Wash",
    type: "Beauty & Health",
    id: 383,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78856635/mxfhp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Smile Dent Mouth Wash",
    type: "Beauty & Health",
    id: 384,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65469701/yovot_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Smile Dent Mouth Wash",
    type: "Beauty & Health",
    id: 385,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/43539137/epaqu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Urban Mooch Tooth Paste",
    type: "Beauty & Health",
    id: 386,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82657021/ubnj9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Urban Mooch Tooth Paste",
    type: "Beauty & Health",
    id: 387,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79099455/nsur0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Urban Mooch Tooth Paste",
    type: "Beauty & Health",
    id: 388,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77863641/muisy_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Urban Mooch Tooth Paste",
    type: "Beauty & Health",
    id: 389,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/43191992/odvxe_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Urban Mooch Tooth Paste",
    type: "Beauty & Health",
    id: 390,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62062070/jnmzn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Attractive Deo",
    type: "Beauty & Health",
    id: 391,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/75362149/5rjrg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Attractive Deo",
    type: "Beauty & Health",
    id: 392,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61142371/khrp5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Attractive Deo",
    type: "Beauty & Health",
    id: 393,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/93532057/8kvro_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Attractive Deo",
    type: "Beauty & Health",
    id: 394,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78056277/nie78_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Unique Attractive Deo",
    type: "Beauty & Health",
    id: 395,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82516405/mmqgw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Axe Classics Deodorant",
    type: "Beauty & Health",
    id: 396,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83292008/uvcf8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Axe Classics Deodorant",
    type: "Beauty & Health",
    id: 397,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/57723624/dc8r5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Axe Classics Deodorant",
    type: "Beauty & Health",
    id: 398,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59953982/2qkgg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Axe Classics Deodorant",
    type: "Beauty & Health",
    id: 399,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/97182992/12qzg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Axe Classics Deodorant",
    type: "Beauty & Health",
    id: 400,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/89023469/zzokd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?beauty",
      "https://source.unsplash.com/random/?health",
      "https://source.unsplash.com/random/?eyes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 401,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63915652/9xghj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 402,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76822834/gl9on_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 403,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/44493980/yj9i9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 404,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62465648/qbvva_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 405,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59186688/raznh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 406,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/52636931/ucqiw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 407,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76776685/ivafz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 408,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/56952733/kooir_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 409,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53145740/96ons_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?flats",
      "https://source.unsplash.com/random/?shoes",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Designer Trendy Stylish",
    type: "Bags & Footwear",
    id: 410,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/67234387/ahklw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 411,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/21376792/4b1f9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 412,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45279915/14j0w_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 413,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74405009/j3p2h_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 414,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59664217/ap1rp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 415,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/35577745/vcdry_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?sandal",
      "https://source.unsplash.com/random/?kid",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 416,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71372746/9abiu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 417,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78960236/wbs5w_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 418,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/47375813/tw1v8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 419,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/43718088/ueocn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Comfy Elegant Bags & Wears",
    type: "Bags & Footwear",
    id: 420,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/51979700/08kcw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 421,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76188016/ir0pt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 422,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/56335077/vfxjg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 423,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70449546/ukmzt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 424,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68451027/jkwoo_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 425,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68449827/hym3i_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 426,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72067809/hwz8f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 427,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/90552278/vo6kb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 428,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/85898688/p5ngj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 429,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54105907/5nakw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 430,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/75730825/kdbh6_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 431,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69778164/6i2yt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 432,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83294262/jsbe0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 433,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74412446/iy0a9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 434,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72992008/c0pnn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Colorful Bags & Footwears",
    type: "Bags & Footwear",
    id: 435,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60126745/tiaas_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 436,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/53160340/8w55a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 437,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77077323/q4har_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 438,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54238573/ygnyu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 439,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/47397209/kgff8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?wallet",
      "https://source.unsplash.com/random/?pocket",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 440,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82950325/byizk_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 441,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/31539468/3lie4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 442,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/50989091/el8kv_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 443,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/88994400/iwcbd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 444,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/48655157/uqkom_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 445,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/48435039/mieln_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 446,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77433080/gp0u1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 447,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/36072753/ajwjg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 448,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16765508/18424_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 449,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/8480418/fec93_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Women Bellies",
    type: "Bags & Footwear",
    id: 450,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/50423487/dl2hr_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 451,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11475375/f5cf0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?sandals",
      "https://source.unsplash.com/random/?belt",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 452,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/91668734/ncvsa_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 453,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/86508804/5zfqq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 454,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/92027352/gwcrc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 455,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/14041918/3a8f5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 456,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/89656264/lh5ot_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 457,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/80527823/tobhj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 458,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/91928960/hlxal_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 459,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71761543/rn7gl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 460,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41624458/p9t2s_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?bags",
      "https://source.unsplash.com/random/?jewellery",
      "https://source.unsplash.com/random/?watch",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 461,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/67940824/kztji_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 462,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81028223/nxjyy_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 463,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/19017433/sofxj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 464,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71498820/49krb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 465,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/24772573/2fa5a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Attractive Bags % Footwear",
    type: "Bags & Footwear",
    id: 466,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77061992/l9erm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Versatile Ravishing Bags",
    type: "Bags & Footwear",
    id: 467,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61389046/xaiyg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Trendy Handbags",
    type: "Bags & Footwear",
    id: 468,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/50169864/l5gbb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Trendy Handbags",
    type: "Bags & Footwear",
    id: 469,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41167052/pi73m_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Trendy Handbags",
    type: "Bags & Footwear",
    id: 470,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83316275/uaxkz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Trendy Handbags",
    type: "Bags & Footwear",
    id: 471,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84845567/mp2w9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Alluring Women Handbags",
    type: "Bags & Footwear",
    id: 472,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/50326993/nxmhm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Alluring Women Handbags",
    type: "Bags & Footwear",
    id: 473,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/41614446/p9yrw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Alluring Women Handbags",
    type: "Bags & Footwear",
    id: 474,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68210893/3asg2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Alluring Women Handbags",
    type: "Bags & Footwear",
    id: 475,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/80783584/rjn8c_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Alluring Women Handbags",
    type: "Bags & Footwear",
    id: 476,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74761899/jxdgs_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Attractive Wears",
    type: "Bags & Footwear",
    id: 477,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/23920358/698f8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Attractive Wears",
    type: "Bags & Footwear",
    id: 478,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42586130/du5ve_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Attractive Wears",
    type: "Bags & Footwear",
    id: 479,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42336772/oqu2n_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Voguish Attractive Wears",
    type: "Bags & Footwear",
    id: 480,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71575537/4oljg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?footwear",
      "https://source.unsplash.com/random/?shoes",
      "https://source.unsplash.com/random/?bags",
    ],
    soldBy: random(Sellers),
    details: [
      "Skin Type : All Skin Types",
      "Flavour : Unflavoured",
      "Multipack : 1",
      "Concern : Anti ageing",
      "Combo of : Single",
    ],
  },
  {
    name: "Stylish Cotton Home Acc",
    type: "Home & Kitchen",
    id: 481,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7563763/fd23f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Stylish Cotton Home Acc",
    type: "Home & Kitchen",
    id: 482,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/19207051/d016a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Stylish Cotton Home Acc",
    type: "Home & Kitchen",
    id: 483,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/25793351/e5a2e_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Stylish Cotton Home Acc",
    type: "Home & Kitchen",
    id: 484,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27478224/63c88_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Stylish Cotton Home Acc",
    type: "Home & Kitchen",
    id: 485,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6733167/3ed76_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Stylish Cotton Home Acc",
    type: "Home & Kitchen",
    id: 486,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11316637/8dfe5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Stylish Cotton Home Acc",
    type: "Home & Kitchen",
    id: 487,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6438455/d5979_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Stylish Cotton Home Acc",
    type: "Home & Kitchen",
    id: 488,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/23475811/33d19_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy Poly Cotton",
    type: "Home & Kitchen",
    id: 489,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/24395563/7964a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy Poly Cotton",
    type: "Home & Kitchen",
    id: 490,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16434105/78bfe_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy Poly Cotton",
    type: "Home & Kitchen",
    id: 491,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/4967612/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy Poly Cotton",
    type: "Home & Kitchen",
    id: 492,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/917643/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy Poly Cotton",
    type: "Home & Kitchen",
    id: 493,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/21043300/4a5bc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy Poly Cotton",
    type: "Home & Kitchen",
    id: 494,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11009634/9096c_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy Poly Cotton",
    type: "Home & Kitchen",
    id: 495,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72817099/r3dtt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy Poly Cotton",
    type: "Home & Kitchen",
    id: 496,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/80262251/bnykm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Elegant Home Kitchen",
    type: "Home & Kitchen",
    id: 497,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61490467/wpbde_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Elegant Home Kitchen",
    type: "Home & Kitchen",
    id: 498,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3256262/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Elegant Home Kitchen",
    type: "Home & Kitchen",
    id: 499,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11738439/babbf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Elegant Home Kitchen",
    type: "Home & Kitchen",
    id: 500,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61840734/mjhmw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Elegant Home Kitchen",
    type: "Home & Kitchen",
    id: 501,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/85212787/kp5b7_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Elegant Home Kitchen",
    type: "Home & Kitchen",
    id: 502,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3670565/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Elegant Home Kitchen",
    type: "Home & Kitchen",
    id: 503,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/19019877/8660e_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Elegant Home Kitchen",
    type: "Home & Kitchen",
    id: 504,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77716213/u00y9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Elegant Home Kitchen",
    type: "Home & Kitchen",
    id: 505,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/26099887/28f3c_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 506,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65260786/8ksqh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 507,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/34107665/he0hd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 508,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62447710/vdtem_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 509,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76373035/kscem_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 510,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70816563/zl3ss_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 511,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/9518100/29a78_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 512,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61367311/yizin_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 513,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7696160/2d22a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 514,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/491911/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 515,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/2454305/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 516,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7767675/83835_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 517,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/33124268/pwq82_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Bedsheets",
    type: "Home & Kitchen",
    id: 518,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/623347/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 519,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16051545/df611_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 520,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/12793714/6352f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 521,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11789285/82890_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 522,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7541956/e93ce_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 523,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81647522/k7vew_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 524,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/87836463/5cooo_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 525,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/19003361/fc08d_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 526,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/24048385/42044_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 527,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/18534883/0a1ee_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 528,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/20588844/6fcfc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 529,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27509306/b8aa8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Ravishing Furnitures",
    type: "Home & Kitchen",
    id: 530,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82051423/qhsve_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 531,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/51976211/odzwd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 532,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/9252619/09097_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 533,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68558190/orgme_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 534,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3368156/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 535,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27970997/c08c2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 536,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/18236875/2fc3f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 537,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/20997692/3df6d_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 538,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3368088/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 539,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3272785/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 540,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7415478/89b73_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 541,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/23432058/5a99f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 542,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/73554811/ypi7c_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 543,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/22213599/1297b_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 544,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7099919/78094_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy TV / Devices",
    type: "Home & Kitchen",
    id: 545,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/73340479/r0aep_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 546,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/18463526/672dc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 547,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3116621/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 548,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/18562470/3e96f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 549,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/73496963/pq2hd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 550,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/65850137/oofpk_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 551,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68908519/5hckm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 552,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74408888/ngink_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 553,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/3119128/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 554,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/18407397/0076d_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 555,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71946557/qxoqe_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Decor Items",
    type: "Home & Kitchen",
    id: 556,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/8132640/85456_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Voguish Attractive Bedsheets",
    type: "Home & Kitchen",
    id: 557,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/25793385/0d867_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Stylish Cotton 100 X 90",
    type: "Home & Kitchen",
    id: 558,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6442407/b7589_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Trendy Poly Cotton Sheet",
    type: "Home & Kitchen",
    id: 559,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6450980/d2073_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Stylish Cotton Bedsheet",
    type: "Home & Kitchen",
    id: 560,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7978969/bfc08_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Kids Soft Toys & Things",
    type: "Kids",
    id: 561,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/47213307/mi22q_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Kids Soft Toys & Things",
    type: "Kids",
    id: 562,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59088437/6vc1r_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Kids Soft Toys & Things",
    type: "Kids",
    id: 563,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63473953/zxpj3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Kids Soft Toys & Things",
    type: "Kids",
    id: 564,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42935577/wygll_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Kids Soft Toys & Things",
    type: "Kids",
    id: 565,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/47288050/bayb1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Kids Soft Toys & Things",
    type: "Kids",
    id: 566,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/56582595/0za0m_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Kids Soft Toys & Things",
    type: "Kids",
    id: 567,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63412560/28lws_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Kids Soft Toys & Things",
    type: "Kids",
    id: 568,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/47128026/fvghv_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Classics Kids Things",
    type: "Kids",
    id: 569,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/50655629/fcvut_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Classics Kids Things",
    type: "Kids",
    id: 570,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81799329/ujfap_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Classics Kids Things",
    type: "Kids",
    id: 571,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63053899/5ajmj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Classics Kids Things",
    type: "Kids",
    id: 572,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/5217560/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Classics Kids Things",
    type: "Kids",
    id: 573,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49652451/g6dig_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Classics Kids Things",
    type: "Kids",
    id: 574,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71500851/sn7wl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Classics Kids Things",
    type: "Kids",
    id: 575,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/57867469/uybrc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Classics Kids Things",
    type: "Kids",
    id: 576,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/69173604/o6ryt_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Kids Things",
    type: "Kids",
    id: 577,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45286059/ymtmk_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Kids Things",
    type: "Kids",
    id: 578,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/34656026/wqmq7_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Kids Things",
    type: "Kids",
    id: 579,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77810694/0fcgn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Kids Things",
    type: "Kids",
    id: 580,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/73854543/7a4ty_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Kids Things",
    type: "Kids",
    id: 581,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78288824/ibile_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Kids Things",
    type: "Kids",
    id: 582,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/22718248/aeda0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Kids Things",
    type: "Kids",
    id: 583,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/45226294/h4vgb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Kids Things",
    type: "Kids",
    id: 584,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63669972/vs0et_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 585,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79887723/riswb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 586,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63130002/4ume5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 587,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66754636/q5br0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 588,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/57933293/o7jwl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 589,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/66754612/v9fur_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 590,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/86420668/at5hj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 591,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/90988793/ybn5i_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 592,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71583275/gtdfh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 593,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/64888100/qjjvq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "New Kids Fashions",
    type: "Kids",
    id: 594,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82275437/9h44i_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 595,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/33593414/cajsm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 596,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/83954756/uselo_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 597,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/33600545/b6omp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 598,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/28102745/faae5_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 599,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77415351/cpjhr_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 600,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/25246043/6653c_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 601,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6595120/05f46_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 602,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54983107/5pmai_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 603,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6595297/jqhi2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 604,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/51564135/obryr_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 605,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72832591/nqlgo_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 606,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68428098/jlu7n_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Latest Things For Kids",
    type: "Kids",
    id: 607,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84176549/kafoh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 608,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59153559/jlcis_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 609,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76854886/sru74_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 610,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42716482/qfb2t_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 611,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62188298/ctenm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 612,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71352908/w1iit_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 613,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/75576189/xatw3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 614,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/57518428/vg2uq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 615,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/82978246/lt74u_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 616,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79955950/v1yjm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 617,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/49652451/g6dig_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Morden Beautiful Causals",
    type: "Kids",
    id: 618,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62729499/25h8t_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 619,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/37346164/08sa1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 620,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/37346172/muima_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 621,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84668646/o2wug_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 622,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71687540/rpmqu_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 623,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42440241/pua42_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 624,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72707233/nqwq6_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 625,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60437846/5xcou_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 626,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/58056075/okpm7_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 627,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72628721/socyn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 628,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79829057/dnt8a_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Baby Sleeping Bags",
    type: "Kids",
    id: 629,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68517058/65dcn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 630,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/62321713/k8j6s_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 631,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/75684471/k5xgi_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 632,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78798340/ik8xa_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 633,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/52925395/ozafw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 634,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/80860225/bjvad_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 635,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61702649/qhext_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 636,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59817236/ptycs_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 637,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59041220/dz6h4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 638,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/24652731/4b7cf_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 639,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/35575591/mthtl_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Polyester Double Toys",
    type: "Kids",
    id: 640,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/18554069/de0a4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?kids",
      "https://source.unsplash.com/random/?toys",
      "https://source.unsplash.com/random/?baby",
    ],
    soldBy: random(Sellers),
    details: [
      `Fabric : ${random(Fabrics)}`,
      `Pattern : ${random(Patterns)}`,
      "Thread Count : 150",
      "Multipack : Pack Of 1",
    ],
  },
  {
    name: "Comfy Smart Watch",
    type: "Electronics",
    id: 641,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79968386/a338s_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Elite Smart Watch",
    type: "Electronics",
    id: 642,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/22269634/f0e13_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Morden Smart Watch",
    type: "Electronics",
    id: 643,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/87706696/f4flp_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Latest Smart Watch",
    type: "Electronics",
    id: 644,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/88841367/ixv7e_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Gorgeous Smart Watch",
    type: "Electronics",
    id: 645,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/73104646/rwjcm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Classic Smart Watch",
    type: "Electronics",
    id: 646,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6279695/ca8db_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Smart Watch",
    type: "Electronics",
    id: 647,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/13493479/3ed0f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Stylish Smart Watch",
    type: "Electronics",
    id: 648,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84379190/9z1f3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Attractive Smart Watch",
    type: "Electronics",
    id: 649,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72633299/0le7g_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Designer Trendy Watch",
    type: "Electronics",
    id: 650,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/80430071/yo2fx_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?watch",
      "https://source.unsplash.com/random/?smartwatch",
      "https://source.unsplash.com/random/?time",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Smasung Mobile Case",
    type: "Electronics",
    id: 651,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79542410/dgxpz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Smasung Mobile Case",
    type: "Electronics",
    id: 652,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78219996/nu2hs_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Smasung Mobile Case",
    type: "Electronics",
    id: 653,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27843674/e8z0l_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Smasung Mobile Case",
    type: "Electronics",
    id: 654,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42062252/8ncks_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Smasung Mobile Case",
    type: "Electronics",
    id: 655,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27830619/nibc2_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Redmi Mobile Case",
    type: "Electronics",
    id: 656,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42062324/o0xy0_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Redmi Mobile Case",
    type: "Electronics",
    id: 657,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/42062192/6yzsz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Redmi Mobile Case",
    type: "Electronics",
    id: 658,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27844885/u4he9_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Redmi Mobile Cover",
    type: "Electronics",
    id: 659,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27841025/qjqqe_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Mobile Cover",
    type: "Electronics",
    id: 660,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/27844659/pbet8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Classic Mini Fans",
    type: "Electronics",
    id: 661,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77865550/igev4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "New Extension Cord",
    type: "Electronics",
    id: 662,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/85005236/5pqtb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "New Collection of Applience",
    type: "Electronics",
    id: 663,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79742608/ieklj_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Air Cooler",
    type: "Electronics",
    id: 664,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81094776/ii6sy_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Mini Fans",
    type: "Electronics",
    id: 665,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/92200126/br7x6_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Classic Table Lamp",
    type: "Electronics",
    id: 666,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/31295201/17c35_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Extension Board",
    type: "Electronics",
    id: 667,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/5768847/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Advance Mushroom LED",
    type: "Electronics",
    id: 668,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6186333/56cbe_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Lampshades",
    type: "Electronics",
    id: 669,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/32014384/2a377_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Washing Machine Case",
    type: "Electronics",
    id: 670,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68726557/wfwe8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Cover and Case",
    type: "Electronics",
    id: 671,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16713795/7bd3c_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Facewash for Men",
    type: "Electronics",
    id: 672,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/2303214/vjfjg_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Stylo Shavers",
    type: "Electronics",
    id: 673,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/85536863/bwltv_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Covid 19 Masks",
    type: "Electronics",
    id: 674,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/5931879/925a3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Shavers",
    type: "Electronics",
    id: 675,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81890085/igcrx_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Shavers",
    type: "Electronics",
    id: 676,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/84845652/eqb55_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Shavers",
    type: "Electronics",
    id: 677,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81884390/i7wt1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fashionable Shavers",
    type: "Electronics",
    id: 678,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59781543/rhy0y_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 679,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/76730479/f64uc_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 680,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/47778446/9iwcd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 681,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/63967076/l9sn8_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 682,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68124193/9xhyk_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 683,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/80415378/71lqb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 684,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72941854/xesad_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 685,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/26115933/275d3_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 686,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/51051198/lvrbz_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 687,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/77295108/waazh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 688,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/14023058/29e71_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 689,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11898680/4ed7e_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 690,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/24417210/fba61_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Mobile Holders",
    type: "Electronics",
    id: 691,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/34204265/5w2jy_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Jars",
    type: "Electronics",
    id: 692,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/16366352/792e7_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Fancy Jars",
    type: "Electronics",
    id: 693,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/11789285/82890_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Heaters New",
    type: "Electronics",
    id: 694,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/7541956/e93ce_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Water Bottles",
    type: "Electronics",
    id: 695,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79359481/uz1yx_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Pendrives 64GB",
    type: "Electronics",
    id: 696,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/72749176/1pjnn_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Pendrives",
    type: "Electronics",
    id: 697,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/67517999/zwwzb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Pendrives",
    type: "Electronics",
    id: 698,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/54113321/p8qxq_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Utility Board",
    type: "Electronics",
    id: 699,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71901370/h59ej_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Remote For TV",
    type: "Electronics",
    id: 700,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/6468725/40549_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Classy Pendrives",
    type: "Electronics",
    id: 701,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/68481226/oo7dw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Wired Speakers",
    type: "Electronics",
    id: 702,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70904127/itxaw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Utility Board",
    type: "Electronics",
    id: 703,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71700384/mef7s_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "New Collection Board",
    type: "Electronics",
    id: 704,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/70894281/k3hao_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "UPS",
    type: "Electronics",
    id: 705,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81591596/6vhjh_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Electronic Utility",
    type: "Electronics",
    id: 706,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78529677/2eoyb_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Wired Speakers",
    type: "Electronics",
    id: 707,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/78593884/92g2z_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Trendy Electronic Utility",
    type: "Electronics",
    id: 708,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74465327/tv3nk_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Wired Speakers",
    type: "Electronics",
    id: 709,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/59512232/sinkw_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Registers",
    type: "Electronics",
    id: 710,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71233069/liqox_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Electrical Wire",
    type: "Electronics",
    id: 711,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/60202146/irdyd_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Electronic Kettles",
    type: "Electronics",
    id: 712,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/20962913/184d4_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Usha Iron",
    type: "Electronics",
    id: 713,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79977062/y9uvs_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Usha Iron",
    type: "Electronics",
    id: 714,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/74775284/ds37w_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Elite Unique Iron",
    type: "Electronics",
    id: 715,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/2441502/1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Latest Irons",
    type: "Electronics",
    id: 716,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/61458192/mpj0f_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Mixer Juicer Grinders",
    type: "Electronics",
    id: 717,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/9316531/d83b1_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Coolers",
    type: "Electronics",
    id: 718,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/81094776/ii6sy_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Vacuum Cleaners",
    type: "Electronics",
    id: 719,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/79065413/xaw0t_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
  {
    name: "Electronic Kettles",
    type: "Electronics",
    id: 720,
    sprice: Math.floor(Math.random() * 1240 + 450),
    aprice: Math.floor(Math.random() * 100 + 1690),
    rating: Math.round(Math.random() * 35 + 15) / 10,
    reviews: Math.round(Math.random() * 1700),
    img: "https://images.meesho.com/images/products/71495607/ybkfm_512.jpg",
    similar: [
      "https://source.unsplash.com/random/?electronic",
      "https://source.unsplash.com/random/?mobile",
      "https://source.unsplash.com/random/?laptop",
    ],
    soldBy: random(Sellers),
    details: [
      "Type : Usb Fan",
      "Product Breadth : 10 Cm",
      "Product Length : 22 Cm",
      "Product Height : 4 Cm",
      "Pack Of : Pack Of 1",
    ],
  },
];
export { allProducts };
